import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { FlagGroupClinic } from '@chiroup/core/types/FlagGroupClinic.type';

const flagService = () => {
  const list = async () => {
    return ChiroUpAPI.get('api', `/flags`, {});
  };

  const clinicsByGroup = (): Promise<FlagGroupClinic[]> => {
    return ChiroUpAPI.get('api', '/flags/clinics', {});
  };

  const update = async (flag: string, group: string, value: boolean) => {
    return ChiroUpAPI.post('api', `/flags/${flag}`, {
      body: {
        group,
        value,
      },
    });
  };

  return { list, clinicsByGroup, update };
};

export default flagService();
